import React from 'react';
import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import Login from './Pages/Login/login.tsx';
import NavBar from './components/NavBar/NavBar.tsx';
import NewUser from './Pages/NewUser/NewUser.tsx';
import Mapa from './Pages/Mapa/Mapa.tsx';
import Home from './Pages/Home/Home.tsx';
import Footer from './components/Footer/Footer.tsx';
import { AuthProvider } from './services/AuthContext.tsx';
import Stores from './Pages/Stores/Stores.tsx';
import StoreDetails from './Pages/StoreDetails/StoreDetails.tsx';
import Profile from './Pages/UserPage/Profile.tsx';
import FavoritesPage from './Pages/FavoritesPage/FavoritesPage.tsx';
import Chatbot from './Pages/Chatbot/chatbot.tsx';
import Curiosidades from './Pages/Curiosidades/Curiosidades.tsx';
import TripPlanner from './Pages/TripPlanner/TripPlanner.tsx';
import { Chatbot as ChatComponent } from './components/Chatbot/chatbot.tsx';
import AdminDashboard from './Pages/AdminDashboard/AdminDashboard.tsx';

function App() {
  React.useEffect(() => {
    // Simulador de contagem de acessos (Visualizações do site)
    const storedViews = localStorage.getItem('@Sergipanidade:site_views');
    const sessionCounted = sessionStorage.getItem('@Sergipanidade:session_counted');
    
    let currentViews = storedViews ? parseInt(storedViews, 10) : 0; // Base inicial

    if (!sessionCounted) {
      currentViews += 1;
      localStorage.setItem('@Sergipanidade:site_views', currentViews.toString());
      sessionStorage.setItem('@Sergipanidade:session_counted', 'true');
    }
  }, []);

  return (
    
    <Router>
      <AuthProvider>
        <Routes>
          <Route path='/NewUser' element={<NewUser />} />
          <Route path='' element={<Login />} />
          <Route path='/admin/dashboard' element={<AdminDashboard />} />
          <Route
            path="*"
            element={
              <>
                <NavBar />
                  <main style={{ minHeight: 'calc(100vh - 80px)' }}>
                    <Routes>
                      <Route path="/Home" element={<Home />} />
                      
                      <Route path="/" element={<Navigate to="/Home" />} />
                      <Route path='/mapa' element={<Mapa />} />
                      <Route path="/estabelecimentos" element={<Stores />} />
                      <Route path="/estabelecimentos/:id" element={<StoreDetails />} />
                      <Route path="/curiosidades" element={<Curiosidades />} />
                      <Route path="favorites" element={<FavoritesPage />} />
                      <Route path="perfil" element={<Profile />} />
                      <Route path='/chat' element={<Chatbot />} />
                      <Route path="/roteiro" element={<TripPlanner />} />
                  </Routes>
                  </main>
                <Footer />
                <ChatComponent />
              </>
            }
          />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;

